export const TRANZILLA_URL_TEMPLATE = `https://direct.tranzila.com/achim5/iframenew.php?currency=1&nologo=1&u71=1&cred_type=1`;

export function setLang(url: string, lang: string): string {
  if (lang === "en") {
    console.log("In lang en");
    url += '&buttonLabel=Donate';
  } else {
    console.log("In lang il");
    url += '&lang=il';
    url += '&buttonLabel=לתרומה';
  }
  return url;
}

export function setStandLocation(url: string, standLocation: string | null): string {
  if (standLocation) {
    url += '&location=' + standLocation;
  }
  return url;
}

export function setSum(url: string, sum: any): string {
  url += '&sum=' + sum;
  return url;
}

export function setRecurring(url: string, recurring: boolean): string {
  console.log({ recurring });
  if (recurring === true) {
    url += '&recur_transaction=4_approved&bit_pay=0';
  } else {
    url += '&bit_pay=1&google_pay=1';
  }
  return url;
}

export function setUserInfo(url: string, phone: string, fullName: string, email: string): string {
  url += '&email=' + email + '&contact=' + fullName + '&phone=' + phone;
  return url;
}

export function setSelelmentUrl(url: string, setelment: string): string {
  url += '&settlement=' + setelment;
  return url;
}

export function setSendMarketingUrl(url: string, sendMarketing: boolean): string {
  url += '&sendMarketing=' + sendMarketing;
  return url;
}

export function mergeParentQueryParams(iframeUrl: string): string {
  if (!iframeUrl || typeof iframeUrl !== 'string') {
    return iframeUrl;
  }

  try {
    const url = new URL(iframeUrl);
    const iframeParams = new URLSearchParams(url.search);
    const parentParams = new URLSearchParams(window.location.search);
    
    parentParams.forEach((value, key) => {
      if (!iframeParams.has(key)) {
        iframeParams.append(key, value);
      }
    });
    
    url.search = iframeParams.toString();
    return url.toString();
  } catch (error) {
    console.error('Error merging query parameters:', error);
    return iframeUrl;
  }
}